var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload_Icon",
    "data-name": "Upload Icon",
    transform: "translate(-1849 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5788",
    "data-name": "Rectangle 5788",
    width: 50,
    height: 50,
    rx: 8,
    transform: "translate(1849 80)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "upload",
    d: "M8.039,7.139,10.1,5.069V13.7a.9.9,0,0,0,1.8,0V5.069l2.061,2.07a.9.9,0,1,0,1.278-1.278l-3.6-3.6a.93.93,0,0,0-1.278,0l-3.6,3.6A.9.9,0,0,0,8.039,7.139ZM19.1,11a.9.9,0,0,0-.9.9v5.4a.9.9,0,0,1-.9.9H4.7a.9.9,0,0,1-.9-.9V11.9a.9.9,0,1,0-1.8,0v5.4A2.7,2.7,0,0,0,4.7,20H17.3A2.7,2.7,0,0,0,20,17.3V11.9A.9.9,0,0,0,19.1,11Z",
    transform: "translate(1863 93.995)",
    fill: "#474b4f",
    opacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/Upload Icon.692f79c86f954d3f8259d361172fa65b.svg";
export { ForwardRef as ReactComponent };